import tccf7StateManager from './tccf7StateManager.js';
import { tccf7Logger } from './tccf7ErrorHandler.js';
import { TCCF7_CONFIG } from './tccf7Constants.js';

/*-------------------------------------------------------------------------------
  ハニーポット（スパム対策）
  - 隠しフィールドへの入力を監視
  - 状態変化時にイベントを発火し、Mainクラスへ通知
--------------------------------------------------------------------------------*/
export default class tccf7HoneyPot {
  /**
   * @param {string} formId - フォームID
   * @param {HTMLElement} form - フォーム要素 (form)
   */
  constructor(formId, form) {
    this.formId = formId;
    this.form   = form;
    this.start  = false;
    
    if (!this.form) return;

    // セレクタとメッセージを定数から取得
    this.honeyClass = TCCF7_CONFIG.SELECTORS.HONEYPOT || '.wpcf7-top_secret';
    this.honeyElem  = this.form.querySelector(this.honeyClass);
    if (!this.honeyElem) return;

    this.message = TCCF7_CONFIG.MESSAGE;
    this.isSpamDetected = false;

    this.tccf7StateManager = tccf7StateManager.getInstance(this.formId, this.form);

    this.init();
  }

  /*----------------------------------------
    初期化
  ------------------------------------------*/
  init() {
    this.start = true;
    this.form.addEventListener('input', () => this.checkHoneyPot());
  }

  /*----------------------------------------
    スパムチェック実行
  ------------------------------------------*/
  checkHoneyPot() {
    if (!this.form.contains(this.honeyElem)) {
      this.honeyElem = this.form.querySelector(this.honeyClass);
    }
    if (!this.honeyElem) return;

    const hasValue = this.honeyElem.value !== '';
    if (this.isSpamDetected === hasValue) return;
    
    this.isSpamDetected = hasValue;
    if (this.isSpamDetected) {
      tccf7Logger.log(this.message.HONEY_POT, this.message.HONEY_POT_LOG, 'error');
      tccf7Logger.showUserError(this.message.HONEY_POT_ERROR, this.form);
    } else {
      tccf7Logger.clearUserError(this.form);
    }

    this.tccf7StateManager.setSpam(this.isSpamDetected);
  }

  /*----------------------------------------
    外部（Mainクラス等）からの状態確認用
  ------------------------------------------*/
  isSpam() {
    return this.isSpamDetected;
  }
}